var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveyCreated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6655 11.9998C18.6655 12.7071 18.3846 13.3854 17.8845 13.8855C17.3844 14.3856 16.7061 14.6665 15.9989 14.6665H7.99886L2.66553 19.9998V5.33317C2.66553 3.8665 3.86553 2.6665 5.33219 2.6665H15.9989C16.7061 2.6665 17.3844 2.94746 17.8845 3.44755C18.3846 3.94765 18.6655 4.62593 18.6655 5.33317V11.9998Z",
    stroke: "#A855F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9989 12H26.6656C27.3729 12 28.0511 12.281 28.5512 12.781C29.0513 13.2811 29.3323 13.9594 29.3323 14.6667V29.3333L23.9989 24H15.9989C15.2917 24 14.6134 23.719 14.1133 23.219C13.6132 22.7189 13.3323 22.0406 13.3323 21.3333V20",
    stroke: "#A855F7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyCreated);
export default __webpack_public_path__ + "static/media/SurveyCreated.274c594c49ec965daa91b4ddb29178b7.svg";
export { ForwardRef as ReactComponent };